import {getSliceValues, randomInt} from "./getSliceValues";

type PlayerType = 'normal' | 'hi' | 'lo' | 'reverse';

const randomize = (
    percentages: any,
    locksRef: React.RefObject<boolean[]>,
    slicesRef: React.RefObject<number[]>,
    samplesRef: React.RefObject<number[]>,
    retrigsRef: React.RefObject<number[]>,
    playerTypesRef: React.RefObject<PlayerType[]>,
    sampleCount: number,
    setSlices: (slices: number[]) => void,
    setSamples: (samples: number[]) => void,
    setRetrigs: (retrigs: number[]) => void,
    setPlayerTypes: (playerTypes: PlayerType[]) => void,
) => {
    for (let i = 0; i < 16; i++) {
        if (locksRef.current[Math.floor(i / 4)]) {
            continue
        }

        // every step follows the sample of the step before it, but the downbeat
        // re-rolls on each mangle — otherwise SWITCH at 0 would stay stuck on
        // the last picked sample forever
        const lastSample = i === 0 ? randomInt(0, sampleCount - 1) : samplesRef.current[i - 1]

        const [player, sliceIndex, sampleIndex, retrig] = getSliceValues(percentages, i, slicesRef.current[i - 1] || 0, lastSample, sampleCount, 0.125, 0)

        slicesRef.current[i] = sliceIndex as number
        samplesRef.current[i] = sampleIndex as number
        retrigsRef.current[i] = retrig as number
        playerTypesRef.current[i] = player as PlayerType
    }

    setSlices([...slicesRef.current])
    setSamples([...samplesRef.current])
    setRetrigs([...retrigsRef.current])
    setPlayerTypes([...playerTypesRef.current])
}

export {randomize}
